(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animation-series-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeAnimationSeries(section) {
    if (!section || section.dataset.animationSeriesInitialized === 'true') return;
    section.dataset.animationSeriesInitialized = 'true';

    var masonryGrid = section.querySelector('.animation-series__grid--masonry');
    var rafId = null;
    var timerId = null;
    var resizeObserver = null;

    function mediaCards() {
      return Array.prototype.slice.call(section.querySelectorAll('.animation-series__media-card'));
    }

    function html5Videos() {
      return Array.prototype.slice.call(section.querySelectorAll('video'));
    }

    function allIframes() {
      return Array.prototype.slice.call(section.querySelectorAll('iframe'));
    }

    function isYouTube(iframe) {
      var src = iframe.getAttribute('src') || '';
      return /youtube\.com|youtube-nocookie\.com|youtu\.be/i.test(src);
    }

    function isVimeo(iframe) {
      var src = iframe.getAttribute('src') || '';
      return /vimeo\.com/i.test(src);
    }

    function pauseIframe(iframe) {
      if (!iframe) return;

      try {
        if (iframe.contentWindow) {
          if (isYouTube(iframe)) {
            iframe.contentWindow.postMessage(JSON.stringify({
              event: 'command',
              func: 'pauseVideo',
              args: []
            }), '*');
            return;
          }

          if (isVimeo(iframe)) {
            iframe.contentWindow.postMessage(JSON.stringify({
              method: 'pause'
            }), '*');
            return;
          }
        }
      } catch (e) {}

      var src = iframe.getAttribute('src');
      if (!src) return;
      iframe.setAttribute('src', src);
    }

    function stopAllOtherMedia(activeElement) {
      html5Videos().forEach(function (video) {
        if (video !== activeElement) {
          try { video.pause(); } catch (e) {}
        }
      });

      allIframes().forEach(function (iframe) {
        if (iframe !== activeElement) {
          pauseIframe(iframe);
        }
      });
    }

    function clearMasonry() {
      if (!masonryGrid) return;

      masonryGrid.classList.remove('is-masonry-ready');
      mediaCards().forEach(function (card) {
        card.style.gridRowEnd = '';
      });
    }

    function runMasonry() {
      if (!masonryGrid) return;

      if (window.innerWidth <= 989) {
        clearMasonry();
        return;
      }

      masonryGrid.classList.add('is-masonry-ready');

      var computed = window.getComputedStyle(masonryGrid);
      var rowHeight = parseFloat(computed.getPropertyValue('grid-auto-rows'));
      var rowGap = parseFloat(computed.getPropertyValue('row-gap'));

      if (!rowHeight) return;

      mediaCards().forEach(function (card) {
        var height = card.offsetHeight;
        var span = Math.max(1, Math.ceil((height + rowGap) / (rowHeight + rowGap)));
        var nextValue = 'span ' + span;

        if (card.style.gridRowEnd !== nextValue) {
          card.style.gridRowEnd = nextValue;
        }
      });
    }

    function scheduleMasonry(delay) {
      clearTimeout(timerId);
      timerId = setTimeout(function () {
        if (rafId) {
          window.cancelAnimationFrame(rafId);
        }

        rafId = window.requestAnimationFrame(function () {
          runMasonry();
          rafId = null;
        });
      }, delay || 0);
    }

    function bindMediaNode(node) {
      if (!node || node.dataset.animationBound === 'true') return;
      node.dataset.animationBound = 'true';

      if (node.tagName && node.tagName.toLowerCase() === 'video') {
        node.addEventListener('play', function () {
          stopAllOtherMedia(node);
        });

        node.addEventListener('playing', function () {
          stopAllOtherMedia(node);
        });

        node.addEventListener('loadedmetadata', function () {
          scheduleMasonry(0);
        });

        node.addEventListener('loadeddata', function () {
          scheduleMasonry(0);
        });

        return;
      }

      if (node.tagName && node.tagName.toLowerCase() === 'iframe') {
        node.addEventListener('load', function () {
          scheduleMasonry(0);
        });
      }
    }

    function bindMediaNodes() {
      html5Videos().forEach(bindMediaNode);
      allIframes().forEach(bindMediaNode);

      if (resizeObserver) {
        mediaCards().forEach(function (card) {
          if (card.dataset.animationResizeObserved === 'true') return;
          card.dataset.animationResizeObserved = 'true';
          resizeObserver.observe(card);
        });
      }
    }

    function handleCardStart(card) {
      if (!card) return;

      var activeVideo = card.querySelector('video');
      var activeIframe = card.querySelector('iframe');

      if (activeVideo) {
        stopAllOtherMedia(activeVideo);
      } else if (activeIframe) {
        stopAllOtherMedia(activeIframe);
      }
    }

    section.addEventListener('click', function (event) {
      var button = event.target.closest('.animation-series__youtube-poster');

      if (button) {
        var shell = button.closest('.animation-series__youtube-shell');
        if (!shell) return;

        var youtubeId = shell.getAttribute('data-youtube-id');
        var title = shell.getAttribute('data-youtube-title') || 'YouTube video';

        if (!youtubeId) return;

        shell.innerHTML =
          '<iframe class="animation-series__iframe" ' +
          'src="https://www.youtube-nocookie.com/embed/' + youtubeId + '?autoplay=1&enablejsapi=1&playsinline=1&rel=0" ' +
          'title="' + title.replace(/"/g, '&quot;') + '" ' +
          'allow="autoplay; encrypted-media; picture-in-picture; web-share" ' +
          'allowfullscreen webkitallowfullscreen></iframe>';

        bindMediaNodes();

        var newIframe = shell.querySelector('iframe');
        if (newIframe) {
          stopAllOtherMedia(newIframe);
        }

        scheduleMasonry(40);
        scheduleMasonry(220);
        return;
      }

      var card = event.target.closest('.animation-series__media-card');
      if (card) {
        handleCardStart(card);
      }
    }, true);

    document.addEventListener('play', function (event) {
      var target = event.target;
      if (!section.contains(target)) return;

      if (target.tagName && target.tagName.toLowerCase() === 'video') {
        stopAllOtherMedia(target);
      }
    }, true);

    window.addEventListener('message', function (event) {
      var data = event.data;

      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {}
      }

      var sourceIframe = null;
      var iframes = allIframes();

      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].contentWindow === event.source) {
          sourceIframe = iframes[i];
          break;
        }
      }

      if (!sourceIframe || !data) return;

      if (data.event === 'onStateChange' && Number(data.info) === 1) {
        stopAllOtherMedia(sourceIframe);
        scheduleMasonry(0);
      }

      if (data.event === 'play' || data.method === 'play') {
        stopAllOtherMedia(sourceIframe);
        scheduleMasonry(0);
      }
    });

    if ('ResizeObserver' in window && masonryGrid) {
      resizeObserver = new ResizeObserver(function () {
        scheduleMasonry(0);
      });

      resizeObserver.observe(masonryGrid);
    }

    function refreshLayout() {
      bindMediaNodes();
      scheduleMasonry(120);
    }

    window.addEventListener('load', function () {
      refreshLayout();
      scheduleMasonry(260);
    }, { once: true });

    window.addEventListener('resize', refreshLayout, { passive: true });

    window.addEventListener('orientationchange', function () {
      clearMasonry();
      bindMediaNodes();
      scheduleMasonry(140);
      scheduleMasonry(360);
      scheduleMasonry(620);
    }, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        bindMediaNodes();
        scheduleMasonry(140);
      }, { passive: true });
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        scheduleMasonry(0);
      }).catch(function () {});
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bindMediaNodes();
            scheduleMasonry(0);
            scheduleMasonry(220);
            io.disconnect();
          }
        });
      }, { rootMargin: '300px 0px' });

      io.observe(section);
    } else {
      bindMediaNodes();
      scheduleMasonry(0);
      scheduleMasonry(220);
    }
  }

  function initializeAnimationSeriesIn(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-animation-series]')) {
      initializeAnimationSeries(scope);
    }

    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-animation-series]'),
      initializeAnimationSeries
    );
  }

  function startAnimationSeries() {
    initializeAnimationSeriesIn(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAnimationSeries, { once: true });
  } else {
    startAnimationSeries();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAnimationSeriesIn(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-product-information"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initArtistProductEditorial(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var variantsDataEl = section.querySelector('[data-product-variants]');
        var variants = [];

        try {
          variants = JSON.parse(variantsDataEl.textContent);
        } catch (e) {
          console.error('Variant JSON error', e);
        }

        var form = section.querySelector('.artist-product-editorial__form');
        var optionSelects = Array.prototype.slice.call(section.querySelectorAll('[data-option-select]'));
        var optionButtons = Array.prototype.slice.call(section.querySelectorAll('[data-option-value]'));
        var variantInput = section.querySelector('[data-variant-id-input]');
    var priceWrap = section.querySelector('[data-product-price]');
    var skuWrap = section.querySelector('[data-product-sku]');
        var addButton = section.querySelector('[data-add-to-cart]');
        var mediaMainImage = section.querySelector('.artist-product-editorial__hero-image');
        var thumbButtons = Array.prototype.slice.call(section.querySelectorAll('[data-media-trigger]'));
        var qtyInput = section.querySelector('.artist-product-editorial__quantity-input');
        var qtyMinus = section.querySelector('[data-qty-minus]');
        var qtyPlus = section.querySelector('[data-qty-plus]');

    var defaultAddLabel = section.dataset.addLabel || 'Add to cart';
    var soldOutLabel = section.dataset.soldLabel || 'Sold out';
        var addingLabel = 'Holding this piece…';
        var addedLabel = 'Added to your collection';

        function money(cents) {
          if (window.Shopify && Shopify.formatMoney && section.dataset.moneyFormat) {
            return Shopify.formatMoney(cents, section.dataset.moneyFormat);
          }
          return '$' + (cents / 100).toFixed(2);
        }

        function normalizeOptionValue(value) {
          return String(value || '')
            .trim()
            .replace(/\s+/g, ' ');
        }

        function getSelectedOptions() {
          return optionSelects.map(function(select) {
            return normalizeOptionValue(select.value);
          });
        }

        function setSelectToExactValue(select, targetValue) {
          if (!select) return false;

          var normalizedTarget = normalizeOptionValue(targetValue);
          var matched = false;

          Array.prototype.slice.call(select.options).forEach(function(option) {
            if (matched) return;
            if (normalizeOptionValue(option.value) === normalizedTarget) {
              select.value = option.value;
              matched = true;
            }
          });

          return matched;
        }

        function findVariant() {
          var selected = getSelectedOptions();

          for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            if (!variant.options || variant.options.length !== selected.length) continue;

            var isMatch = true;

            for (var j = 0; j < selected.length; j++) {
              if (normalizeOptionValue(variant.options[j]) !== selected[j]) {
                isMatch = false;
                break;
              }
            }

            if (isMatch) return variant;
          }

          return null;
        }

        function findVariantByMediaId(mediaId) {
          if (!mediaId) return null;

          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].featured_media_id) === String(mediaId)) {
              return variants[i];
            }
          }

          return null;
        }

        function findBestVariantForMedia(mediaId) {
          if (!mediaId) return null;

          var currentVariant = findVariant();
          var selected = getSelectedOptions();
          var bestVariant = null;
          var bestScore = -1;

          if (currentVariant && String(currentVariant.featured_media_id) === String(mediaId)) {
            return currentVariant;
          }

          for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            if (String(variant.featured_media_id) !== String(mediaId)) continue;

            var score = 0;
            for (var j = 0; j < variant.options.length; j++) {
              if (normalizeOptionValue(variant.options[j]) === selected[j]) {
                score++;
              }
            }

            if (score > bestScore) {
              bestScore = score;
              bestVariant = variant;
            }
          }

          return bestVariant || findVariantByMediaId(mediaId);
        }

        function updateOptionButtons() {
          optionButtons.forEach(function(button) {
            button.classList.remove('is-active');
            button.setAttribute('aria-pressed', 'false');
          });

          optionSelects.forEach(function(select) {
            var index = String(select.getAttribute('data-option-index'));
            var selectedValue = normalizeOptionValue(select.value);

            optionButtons.forEach(function(button) {
              if (String(button.getAttribute('data-option-index')) !== index) return;

              var buttonValue = normalizeOptionValue(button.getAttribute('data-option-value'));
              if (buttonValue === selectedValue) {
                button.classList.add('is-active');
                button.setAttribute('aria-pressed', 'true');
              }
            });
          });
        }

        function applyVariantToOptions(variant) {
          if (!variant || !variant.options) return;

          optionSelects.forEach(function(select, index) {
            if (typeof variant.options[index] === 'undefined') return;
            setSelectToExactValue(select, variant.options[index]);
          });

          updateOptionButtons();
          updateUI(variant);
        }

        function setMainImage(src, srcset, full, alt) {
          if (mediaMainImage && src) {
            mediaMainImage.src = src;

            if (srcset) {
              mediaMainImage.srcset = srcset;
            } else {
              mediaMainImage.removeAttribute('srcset');
            }

            mediaMainImage.alt = alt || '';
          }
        }

        function activateMatchingThumb(mediaId) {
          thumbButtons.forEach(function(btn) {
            btn.classList.remove('is-active');
          });

          if (!mediaId) return;

          var matchingThumb = section.querySelector('[data-media-id="' + mediaId + '"]');
          if (matchingThumb) {
            matchingThumb.classList.add('is-active');
          }
        }

        function updateMediaByVariant(variant) {
          if (!variant) return;

          if (variant.featured_image && variant.featured_image.src) {
            setMainImage(
              variant.featured_image.src,
              variant.featured_image.srcset,
              variant.featured_image.full,
              variant.featured_image.alt
            );
          }

          activateMatchingThumb(variant.featured_media_id);
        }

        function updateUI(variant) {
          if (!variant) {
            if (addButton) {
              addButton.disabled = true;
              addButton.textContent = soldOutLabel;
            }
            return;
          }

          if (variantInput) {
            variantInput.value = variant.id;
          }

          if (priceWrap) {
            var compareHtml = '';
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              compareHtml = '<span class="artist-product-editorial__price-compare">' + money(variant.compare_at_price) + '</span>';
            }

            priceWrap.innerHTML =
              compareHtml +
              '<span class="artist-product-editorial__price-current">' + money(variant.price) + '</span>';
          }

          if (skuWrap) {
            skuWrap.textContent = variant.sku || '';
          }

          if (addButton) {
            addButton.disabled = !variant.available;
            addButton.textContent = variant.available ? defaultAddLabel : soldOutLabel;
          }

          updateMediaByVariant(variant);

          if (section.dataset.productUrl && window.history.replaceState) {
            var url = new URL(section.dataset.productUrl, window.location.origin);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
        }

        function triggerSelectChange(select) {
          var event;
          try {
            event = new Event('change', { bubbles: true });
          } catch (e) {
            event = document.createEvent('Event');
            event.initEvent('change', true, true);
          }
          select.dispatchEvent(event);
        }

        function refreshCartBubble() {
          fetch(window.Shopify.routes.root + 'cart.js', {
            headers: { Accept: 'application/json' }
          })
            .then(function(response) {
              return response.json();
            })
            .then(function(cart) {
              var count = cart.item_count;

              document.querySelectorAll(
                '.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble .count, [data-cart-count]'
              ).forEach(function(node) {
                node.textContent = count;
              });

              document.querySelectorAll('.cart-count-bubble').forEach(function(bubble) {
                if (count > 0) bubble.classList.remove('hidden');
                else bubble.classList.add('hidden');
              });

              return fetch(window.Shopify.routes.root + '?section_id=cart-icon-bubble');
            })
            .then(function(response) {
              return response.text();
            })
            .then(function(htmlText) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(htmlText, 'text/html');
              var newBubble = doc.querySelector('#cart-icon-bubble');
              var currentBubble = document.querySelector('#cart-icon-bubble');

              if (newBubble && currentBubble) {
                currentBubble.innerHTML = newBubble.innerHTML;
              }
            })
            .catch(function() {});
        }

        optionButtons.forEach(function(button) {
          button.addEventListener('click', function() {
            var optionIndex = String(button.getAttribute('data-option-index'));
            var rawValue = button.getAttribute('data-option-value');
            var select = section.querySelector('[data-option-select][data-option-index="' + optionIndex + '"]');

            if (!select) return;

            setSelectToExactValue(select, rawValue);
            triggerSelectChange(select);
          });
        });

        optionSelects.forEach(function(select) {
          select.addEventListener('change', function() {
            var variant = findVariant();
            updateOptionButtons();
            updateUI(variant);
          });
        });

        thumbButtons.forEach(function(button) {
          button.addEventListener('click', function() {
            var mediaId = button.getAttribute('data-media-id');
            var matchingVariant = findBestVariantForMedia(mediaId);

            if (matchingVariant) {
              applyVariantToOptions(matchingVariant);
              updateOptionButtons();
            } else {
              activateMatchingThumb(mediaId);
              setMainImage(
                button.getAttribute('data-media-src'),
                button.getAttribute('data-media-srcset'),
                button.getAttribute('data-media-full'),
                button.getAttribute('data-media-alt') || ''
              );
            }
          });
        });

        if (qtyMinus && qtyInput) {
          qtyMinus.addEventListener('click', function() {
            var step = parseInt(qtyInput.step || 1, 10);
            var min = parseInt(qtyInput.min || 1, 10);
            var value = parseInt(qtyInput.value || min, 10);
            qtyInput.value = Math.max(min, value - step);
          });
        }

        if (qtyPlus && qtyInput) {
          qtyPlus.addEventListener('click', function() {
            var step = parseInt(qtyInput.step || 1, 10);
            var value = parseInt(qtyInput.value || 1, 10);
            qtyInput.value = value + step;
          });
        }

        if (form) {
          form.addEventListener('submit', function(event) {
            event.preventDefault();

            var variant = findVariant();
            if (!variant || !variant.available) return;

            var quantity = qtyInput ? parseInt(qtyInput.value || 1, 10) : 1;
            if (!quantity || quantity < 1) quantity = 1;

            if (addButton) {
              addButton.disabled = true;
              addButton.textContent = addingLabel;
            }

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variant.id,
                    quantity: quantity
                  }
                ]
              })
            })
              .then(function(response) {
                if (!response.ok) throw new Error('Cart add failed');
                return response.json();
              })
              .then(function() {
                refreshCartBubble();

                document.dispatchEvent(new CustomEvent('cart:refresh'));
                document.dispatchEvent(new CustomEvent('cart:open'));

                if (addButton) {
                  addButton.textContent = addedLabel;
                }

                setTimeout(function() {
                  if (addButton) {
                    addButton.disabled = false;
                    addButton.textContent = defaultAddLabel;
                  }
                }, 1600);
              })
              .catch(function(error) {
                console.error(error);
                if (addButton) {
                  addButton.disabled = false;
                  addButton.textContent = defaultAddLabel;
                }
              });
          });
        }

        updateOptionButtons();
        updateUI(findVariant());
      }

  function initializeArtistProducts(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-artist-product-editorial]')) {
      initArtistProductEditorial(scope);
    }

    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-artist-product-editorial]'),
      initArtistProductEditorial
    );
  }

  function bootArtistProducts() {
    initializeArtistProducts(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootArtistProducts, { once: true });
  } else {
    bootArtistProducts();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeArtistProducts(event.target);
  });

  document.addEventListener('contextmenu', function(event) {
    if (event.target.closest('.no-save-wrap')) {
      event.preventDefault();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artist-product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('artist-product-recommendations')) return;

  customElements.define(
    'artist-product-recommendations',
    class ArtistProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.hasLoaded = false;
      }

      connectedCallback() {
        if (this.hasLoaded) return;

        if (!('IntersectionObserver' in window)) {
          this.loadRecommendations();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0] || !entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.loadRecommendations();
          },
          { rootMargin: '300px 0px' }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      loadRecommendations() {
        if (this.hasLoaded) return;

        const url = this.dataset.url;
        if (!url) return;

        this.hasLoaded = true;
        this.setAttribute('aria-busy', 'true');

        fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Product recommendations request failed: ' + response.status);
            }
            return response.text();
          })
          .then((htmlText) => {
            const documentFragment = new DOMParser().parseFromString(htmlText, 'text/html');
            const recommendations =
              documentFragment.querySelector('artist-product-recommendations') ||
              documentFragment.querySelector('product-recommendations');

            if (!recommendations) return;

            const content = recommendations.innerHTML.trim();
            if (!content) return;

            this.innerHTML = content;
          })
          .catch((error) => {
            this.hasLoaded = false;
            console.error('Product recommendations failed to load', error);
          })
          .finally(() => {
            this.removeAttribute('aria-busy');
          });
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
